// extracted by mini-css-extract-plugin
module.exports = {"prefooter":"sKK8","prefooterHeadline":"s2MK","promotion":"s16a","promotionText":"s1N-","promotionLinks":"sw1F"};